import { axios } from '@/utils/axios'

// 获取个人信息
export async function fetchInfo (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/info',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 修改密码
export async function changePassword (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/modify/password',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 设置密码
export async function settingPassword (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/password/set',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 设置个人信息
export async function modifyInfo (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/modify',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 绑定手机、邮箱
export async function binding (type, params) {
  try {
    return await axios({
      url: type === 'mobile' ? '/psg-community-user/api/user/bind/mobile' : '/psg-community-user/api/user/bind/email',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 修改手机、邮箱
export async function changeBinding (type, params) {
  try {
    return await axios({
      url: type === 'mobile' ? '/psg-community-user/api/user/modify/phone' : '/psg-community-user/api/user/modify/email',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 银联实名认证
export async function authenticate (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/common/realName/validate',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 设置用户证件信息
export async function certificate (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/addIdentifyInfo',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 金鹏卡绑定
export async function ffpBinding (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/ffp/user/bind',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 实名认证金鹏卡绑定
export async function ffpBindingRealName (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/ffp/user/realname/bind',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 风控-创建新用户
export async function securityCreate (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/create',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 风控-安全校验
export async function securityVerify (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/risk/verify',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取代理人个人信息
export async function fetchAgentInfo (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/agent/detail',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取代理人子账号列表
export async function fetchSubAgentList (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/agentUser/list',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 添加子账号
export async function addSubAgent (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/agentUser/add',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 子代理人状态切换
export async function changeAgentStatus (params) {
  try {
    return await axios({
      url: `/psg-community-user/api/agentUser/${params.event}/${params.userId}`,
      method: 'put',
      data: {}
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 一级代理信息编辑
export async function modifyAgent (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/agent/modify',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 二级代理信息编辑
export async function modifySubAgent (agentId, params) {
  try {
    return await axios({
      url: `/psg-community-user/api/agentUser/${agentId}/modify`,
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 验证密码
export async function checkKey (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/checkKey',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 主动注销
export async function cancel (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/cancel',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取职业身份信息
export async function fetchProfessionalInfo (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/professional/filterByCategory',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 审核列表
export async function fetchAuthList (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/professional/authList',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取身份类型列表
export async function fetchIdentityList (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/professional/loadIdentityList',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 提交身份认证申请
export async function submitProfessional (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/professional/save',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 上传文件
export async function uploadProfessionalFile (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/professional/upload',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取微信小程序码
export async function getWxPayQrCode () {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/common/getWxPayQrCodeBase64',
      method: 'get'
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取微信小程序码 - 人脸识别（可以通过调整入参支持微信支付、银联等其他方式）
export async function getCommonQrCode (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/common/realName/getRealNameQrCodeBase64',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 判断用户是否实名认证
export async function fetchAuthStatus (params = {}) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/checkAuthStatus',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 弱密码修改密码
export async function changeLoginPassword (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/modifyFFP/changeLoginPassword',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
